import { useState, useCallback } from 'react';

export type ToastVariant = 'default' | 'success' | 'error' | 'warning';

export interface Toast {
  id: string;
  title: string;
  description?: string;
  variant: ToastVariant;
}

let toastIdCounter = 0;

// Simple toast store (could be replaced with a proper library)
type ToastListener = (toasts: Toast[]) => void;
const listeners: Set<ToastListener> = new Set();
let toasts: Toast[] = [];

function notify() {
  listeners.forEach((l) => l([...toasts]));
}

export const toast = {
  show(message: string, variant: ToastVariant = 'default', description?: string) {
    const id = String(++toastIdCounter);
    toasts = [...toasts, { id, title: message, description, variant }];
    notify();
    setTimeout(() => {
      toasts = toasts.filter((t) => t.id !== id);
      notify();
    }, 4000);
  },
  success(msg: string, description?: string) { this.show(msg, 'success', description); },
  error(msg: string, description?: string) { this.show(msg, 'error', description); },
  warning(msg: string, description?: string) { this.show(msg, 'warning', description); },
};

export function useToastState() {
  const [currentToasts, setCurrentToasts] = useState<Toast[]>([]);

  const subscribe = useCallback(() => {
    const listener: ToastListener = (t) => setCurrentToasts(t);
    listeners.add(listener);
    return () => listeners.delete(listener);
  }, []);

  return { currentToasts, subscribe };
}
